import { Component, Element, h, Host, Listen } from "@stencil/core";
import {
  ClickElementTypes,
  DisplayElementTypes,
  ElementTypes,
  EventActions,
} from "@phn/utility/constants";
import { getCurrentRoute, reset } from "@phn/services/routing-manager";
import analyticsManager from "../../../../shared/services/analytics/analytics-manager";
import { GlobalDataLayerService } from "../../../../shared/services/analytics/global-data-layer-service";
import windowService from "../../../../shared/services/window-service";

@Component({
  tag: "phn-nd-backdrop",
  styleUrl: "backdrop.scss",
  scoped: true,
})
export class Backdrop {
  @Element() el!: HTMLPhnNdBackdropElement;

  @Listen("click", { passive: true })
  handleClick(): void {
    this.sendDataAnalyticsEvent();
    reset();
  }

  private sendDataAnalyticsEvent() {
    analyticsManager.setDrawerType(DisplayElementTypes.DoubleDrawer);
    GlobalDataLayerService.getInstance().pushDataLayerEvent(
      EventActions.MENU_CLOSE_CLICK,
      {
        componentClick: {
          clickElementId: "mainmenu.drawer.close",
          clickElementName: "backdrop",
          clickElementType: ClickElementTypes.Button,
          targetElement: "level-0",
        },
        componentDisplay: {
          displayElementType: analyticsManager.calculateDisplayElementType(
            getCurrentRoute(),
            ElementTypes.backdrop,
          ),
          displayElementId: analyticsManager.calculateDisplayElementId(),
          displayElementName: "Double Drawer",
        },
      },
    );
  }

  componentWillLoad(): void {
    if (windowService.hasScrollbar()) {
      windowService.lockScroll();
    }
  }

  disconnectedCallback(): void {
    if (windowService.hasScrollbar()) {
      windowService.unlockScroll();
    }
  }

  render(): HTMLPhnNdBackdropElement {
    return <Host />;
  }
}
